import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { SelectedColorBlock, ArrowBlock, OptionsListElement, RelativeBlock } from '../../../Blocks/components/common/StyledEditables';

const TextColor = ({ active, style }) =>
<RelativeBlock>
    <OptionsListElement>
      <span>
        <Icon
        name="txtcolor"
        color="white"
        size={18} />

        <SelectedColorBlock style={{ background: style.color || '#1A1F24' }} />
      </span>
      <ArrowBlock
      active={active}
      name="arrowdown"
      color="white"
      size={12} />

    </OptionsListElement>
  </RelativeBlock>;


export default TextColor;